var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"/api/api-gch.html","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }